import React from 'react';
import history from '../History';
import './Header.css';

const Header = () => {
    return (
        <header className="top-bar">
            <div className="menu">
                <a href="" onClick={() => history.push('/')} className="menu-buttons">
                    Home </a>
            </div>
            <div className="menu">
                <a href="" onClick={() => history.push('/about')} className="menu-buttons">
                    About </a>
            </div>
        </header>
    )
}

export default Header